import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

export class StudentMenu implements IIndexable {
  /**
   * needs to match nk
   */
  id: string;
  nk: string;
  rank: number;
  display_in_menu: boolean;
  icon: string;
  icon_color: string;
  is_in_beta: boolean;
  name: string;
  url: string;
  icon_theme: string;
  title: string;
  uri: string;
  release_status?: string;
  badge_count?: number;
  target: string;
  is_new: boolean;

  constructor(studentMenu: Partial<StudentMenu>) {
    _4.merge(this, studentMenu);
  }

  static build(studentMenu: Partial<StudentMenu>): StudentMenu {
    return new StudentMenu(studentMenu);
  }
}



// WEBPACK FOOTER //
// ./app/lib/responsive_navigation/builders/student_menu_builder.ts